module.exports = __webpack_public_path__ + "static/media/offline_bbps.c9c44d3f.svg";